const error_routes = [
    {
        path: '/errors/generic',
        name: 'error',
        meta: {
            title: 'Error',
            slug: 'errors',
            icon: 'AlertOctagonIcon',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/errors/Error.vue')
    },
    {
        path: '/errors/404',
        name: '404',
        meta: {
            title: 'Error 404',
            slug: 'errors',
            icon: 'AlertOctagonIcon',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/errors/404.vue')
    },
    {
        path: '/errors/401',
        name: '401',
        meta: {
            title: 'Error 401',
            slug: 'errors',
            icon: 'AlertOctagonIcon',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/errors/401.vue')
    }
]

export default error_routes
